@import "../../scss";

.root {
  width: 25rem;
  border-radius: 1.25rem;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  padding: var(--spacer-3) var(--spacer-2);
  background: var(--color-swamp-green);
  color: var(--color-cream);
  transform-style: preserve-3d;

  @include media-breakpoint-down("sm") {
    padding: var(--spacer-2);
  }
}

.image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: contain;
}

.image-wrapper {
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 1.25rem;
  flex-shrink: 0;
  @include media-breakpoint-down("sm") {
    width: 80%;
  }
}

.image-wrapper::before {
  content: "";
  padding-bottom: 120%;
  display: block;
  height: 0;
}

.heading {
  position: relative;
  text-align: center;
  position: absolute;
  top: 2.2rem;
  left: 0;
  right: 0;
  color: #fff;
  text-transform: uppercase;
}

.heading__intro {
  @include typo--small-label();
}

.heading__name {
  @include typo--plant-card-plant-name();
}

.body {
  text-align: center;
  @include typo--plant-card-body();
}
